import { atomWithStorage } from 'jotai/utils';

/** Tema disponíveis na aplicação */
export type Theme = 'light' | 'dark';

/**
 * Átomo do tema da aplicação.
 *
 * Usa `atomWithStorage` para persistir a preferência no `localStorage`.
 * Chave de storage: `'mbx.theme'`
 *
 * NUNCA use este átomo diretamente em componentes.
 * Use o hook `useTheme()` de `@/shared/store/hooks/useTheme`.
 *
 * @example
 * ```ts
 * // Correto — via hook
 * const { theme, toggle } = useTheme();
 *
 * // Errado — átomo diretamente no componente
 * const [theme] = useAtom(themeAtom);
 * ```
 */
export const themeAtom = atomWithStorage<Theme>('mbx.theme', 'light');
themeAtom.debugLabel = 'shared/themeAtom';
